var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_494_2679",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11.3113,
    height: 11.3113,
    rx: 5.65564,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_494_2679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.79865 7.57621C6.90064 7.68612 7.02629 7.74108 7.1756 7.74108C7.32491 7.74108 7.45847 7.68216 7.5763 7.56434C7.69413 7.45443 7.75106 7.32284 7.7471 7.16957C7.74314 7.01649 7.68621 6.88886 7.5763 6.78669L7.38278 6.59151C6.6387 5.84106 6.22121 4.82705 6.22121 3.77025C6.22121 3.62113 6.17012 3.49746 6.06794 3.39924C5.96595 3.30102 5.83634 3.25191 5.67912 3.25191C5.52999 3.25191 5.40237 3.303 5.29623 3.40518C5.19028 3.50717 5.1373 3.63282 5.1373 3.78213V5.62021C5.1373 5.69882 5.15295 5.77546 5.18425 5.85011C5.21573 5.92458 5.259 5.99329 5.31404 6.05626L6.79865 7.57621ZM5.65564 10.6984C4.95661 10.6984 4.30074 10.5669 3.68805 10.3039C3.07535 10.0408 2.54118 9.68134 2.08552 9.22568C1.62987 8.77002 1.27045 8.23585 1.00727 7.62316C0.744287 7.01046 0.612793 6.3546 0.612793 5.65556C0.612793 4.95652 0.746266 4.30066 1.01321 3.68796C1.28035 3.07527 1.63976 2.54307 2.09146 2.09137C2.54316 1.63968 3.07535 1.27828 3.68805 1.00719C4.30074 0.736283 4.95661 0.60083 5.65564 0.60083C6.35468 0.60083 7.01055 0.736283 7.62324 1.00719C8.23594 1.27828 8.76813 1.63968 9.21983 2.09137C9.67153 2.54307 10.0329 3.07527 10.304 3.68796C10.5749 4.30066 10.7104 4.95652 10.7104 5.65556C10.7104 6.3546 10.5749 7.01046 10.304 7.62316C10.0329 8.23585 9.67153 8.76805 9.21983 9.21974C8.76813 9.67144 8.23594 10.0309 7.62324 10.298C7.01055 10.5649 6.35468 10.6984 5.65564 10.6984ZM5.65564 9.46124C6.70043 9.46124 7.59591 9.09211 8.34207 8.35386C9.08824 7.61543 9.46132 6.71599 9.46132 5.65556C9.46132 4.60304 9.09022 3.70559 8.34801 2.96319C7.60561 2.22098 6.70816 1.84988 5.65564 1.84988C4.60313 1.84988 3.70567 2.22098 2.96328 2.96319C2.22107 3.70559 1.84996 4.60304 1.84996 5.65556C1.84996 6.71599 2.22107 7.61543 2.96328 8.35386C3.70567 9.09211 4.60313 9.46124 5.65564 9.46124Z",
    fill: "#8D8D8D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.05326ddc00216bae1a8dc19fb5adcbee.svg";
export { ForwardRef as ReactComponent };